export default "__VITE_ASSET__Dr25m35w__"